import axios from "axios";

export const changePassword = async (oldPassword: string, newPassword: string, confirmPassword: string) => {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+"/user/change-password", {
        password: oldPassword,
        new_password: newPassword,
        new_password_confirmation: confirmPassword
    });
    return response.data;
}